export default host => type_names =>
  `${host}/contentCreators/export?${type_names ? `&type_names=${type_names.map(type_name => type_name.value + ",")}` : ''}`

